import React from 'react';
import { getAssetSrc, formatTime } from '../../../../utils/helper';
import { LeaveRoom } from '../../../LeaveRoom';
import { ASSET_NAMES } from '../../../../common/constants';

const QuestionInfo = ({ form, timer, handleEndCall }) => {
    const posName = form?.positionTitle ?? 'Position Name';
    const candidateName = form?.candidateName ?? 'Candidate Name';
    return (
        <div className="question-info-container">
            <div className="question-info-div d-flex flex-column flex-sm-row gap-10 gap-sm-50 align-items-center justify-content-between">
                <img src={getAssetSrc(ASSET_NAMES.INCRUITER_LOGO)} alt="logo" className="main-view-logo" />
                <div className="end-btn-container">
                    <LeaveRoom handleEndCall={handleEndCall} />
                </div>
                <div className="header-sidebar-container">
                    <div className="question-timer-div-main d-flex gap-10 org-position-container">
                        <div className="question-title org-position" title={candidateName}>
                            Candidate Name
                            <br />
                            {candidateName}
                        </div>
                        <div className="question-title org-position" title={posName}>
                            Position Name
                            <br />
                            {posName}
                        </div>
                        <div className="question-titlev2 org-position">
                            Time Left
                            <br />
                            {formatTime(timer) ?? '00:00'}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default QuestionInfo;
